import styled from "styled-components";

interface LeftNavWrapperProps {
    isCollapsed?: boolean;
}

export const LeftNavWrapper = styled.div<LeftNavWrapperProps>`
    width: ${(props) => (props.isCollapsed ? "64px" : "311px")};
    min-width: 64px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    gap: 6px;
    padding-top: 12px;
    border-right: 1px solid #D5D5D5;

    transition: ${(props) =>
        props.isCollapsed ? "width 0.3s ease" : "width 0.3s ease"};
`;
